<template>
  <v-list-group fluid>
    <template #activator="{ props }">
      <v-list-item
        v-bind="props"
        :title="title"
        :prepend-icon="icon"
        link
        nav
      />
    </template>

    <v-list-item
      v-for="(item, i) in items"
      :key="i"
      :prepend-icon="item.icon"
      :title="item.title"
      :to="item.to"
      link
      nav
    />
  </v-list-group>
</template>
<script setup lang="ts">
  defineProps({
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    items: {
      type: Array<{
        to: string;
        title: string;
        icon: string;
      }>,
      required: true,
    },
  });
</script>
